import { defineStore } from 'pinia'
import { alertBox } from '@/composables/silverBox';
import { useBasket } from '@/store/basket'
export const useProcessProduct = defineStore('product', {
    state: () => {
        return {
            inputNumber: [],
            basketArray: [],
            buttonFlag: [],
            buttonsActive: true
        }
    },
    getters: {
    },
    actions: {
        verifySelect(sid, pid) {
            this.getLocalStorage()
            this.buttonFlag[pid] = true;
            this.inputNumber[pid] = 1;
            if (this.basketArray) {
                let storeBasketIndex = this.basketArray.findIndex(elem => elem[2] == sid)
                if (storeBasketIndex > -1) {
                    let productIndex = this.basketArray[storeBasketIndex][0].indexOf(pid);
                    if (productIndex > -1) {
                        this.buttonFlag[pid] = false;
                        let basketQuanitity = this.basketArray[storeBasketIndex][1][productIndex]
                        this.inputNumber[pid] = basketQuanitity;
                    }
                }
            }
        },
        addToBasket(type, sid, pid, quantity) {
            this.getLocalStorage();
            // محصول به حالت انتخاب شده
            this.buttonFlag[pid] = false
            // افزودن به سبد خرید
            if (type != 3) {
                // اگر سبد خرید پر بود
                if (this.basketArray) {
                    // چک کردن موجود بودن سبد خرید از این فروشگاه
                    let storeID = this.basketArray.find(basket => basket[2] == sid)
                    if (storeID) {
                        // اگر از این فروشگاه سبد خرید داشت
                        // ایندکس فروشگاه در سبد خرید کلی
                        let storeBasketIndex = this.basketArray.findIndex(elem => elem[2] == sid)
                        if (this.basketArray[storeBasketIndex][0].indexOf(pid) < 0) {
                            //اگر محصول مورد نظر در سبد خرید وجود نداشت یک ایتم یک دانه ای از ان درست کن
                            this.basketArray[storeBasketIndex][0].push(pid)
                            this.basketArray[storeBasketIndex][1].push(1)
                        } else {
                            //اگر محصول در سبد خرید وجود داشت به تعدادش یکی اضافه کن
                            // ایندکس محصول در ارایه سبد خرید فروشگاه
                            let productIndex = this.basketArray[storeBasketIndex][0].indexOf(pid);
                            let basketQuanitity = this.basketArray[storeBasketIndex][1][productIndex]
                            if (quantity - basketQuanitity > 0) {
                                // اگر محصول موجودی داشت به تعدادش یکی اضافه کن
                                this.basketArray[storeBasketIndex][1][productIndex] += 1;
                                // اضافه کردن تعداد نمایشی
                                this.inputNumber[pid]++;
                            } else {
                                // اگر موجودی محصول تمام شده بود
                                alertBox("موجودی این محصول تمام شده است.", 'error')
                            }
                        }
                        this.addToLocalStorage()
                    } else {
                        // اگر از این فروشگاه سبد خرید نداشت
                        // ساختن اولین محصول با تعداد 1 
                        let newItem = [[pid], [1], Number(sid)]
                        this.basketArray.push(newItem)
                        this.addToLocalStorage()
                        alertBox('سبد خرید اضافه شد', 'success', 2)
                    }

                } else {
                    // اگر سبد خرید خالی بود
                    this.basketArray = []
                    let newItem = [[pid], [1], Number(sid)]
                    this.basketArray.push(newItem)
                    this.setBasketSupplierID(Number(sid))
                    this.addToLocalStorage()
                    alertBox('سبد خرید اضافه شد', 'success', 2)
                }

            } else {
                // type == 3
                //فشردن دکمه -
                if (this.inputNumber[pid] > 1) {
                    //زمانی که از تعداد محصول میکاهیم قبل از به صفر رسیدن
                    this.inputNumber[pid]--;
                    this.removeLocalStorage(sid, pid)
                } else {
                    //در صورتی ک تعداد محصول به صفر رسید
                    this.buttonFlag[pid] = true;
                    this.removeLocalStorage(sid, pid)
                }
            }
            const storeBasket = useBasket();
            storeBasket.isCustomShown = true

            this.buttonsActive = false
            storeBasket.getBasket()
            storeBasket.getSupplierNames()
            storeBasket.clearDamp()
        },
        removeLocalStorage(sid, pid) {
            let storeBasketIndex = this.basketArray.findIndex(elem => elem[2] == sid)
            let productIndex = this.basketArray[storeBasketIndex][0].indexOf(pid);
            let basketQuanitity = this.basketArray[storeBasketIndex][1][productIndex]
            // کم کردن تعداد محصول
            basketQuanitity -= 1;
            this.basketArray[storeBasketIndex][1][productIndex] = basketQuanitity;
            if (basketQuanitity <= 0) {
                // اگر تعداد انتخابی محصول به صفر رسید
                // console.log('count is zero');
                this.basketArray[storeBasketIndex][0].splice(productIndex, 1);
                this.basketArray[storeBasketIndex][1].splice(productIndex, 1);
                if (!this.basketArray[storeBasketIndex][1].length) {
                    // console.log('store is empty');
                    this.basketArray.splice(storeBasketIndex, 1)
                    alertBox('سبد این فروشگاه پاک شد', 'info', 2)
                    if (this.basketArray.length) {
                        // console.log('basket not empty yettt');
                        this.setBasketSupplierID(this.basketArray[0][2])
                    }
                }
            }
            if (this.basketArray.length) {
                // اگر سبد خرید خالی نشده بود
                // console.log('basket not empty yet');
                this.addToLocalStorage()
            } else {
                // اگر سبد خرید کلی خالی شده بود
                // console.log('basket reset');
                localStorage.removeItem('basket')
                localStorage.removeItem('bsID')
            }

        },
        addToLocalStorage() {
            localStorage.setItem('basket', JSON.stringify(this.basketArray))
        },
        setBasketSupplierID(id) {
            localStorage.setItem('bsID', id)
        },
        getLocalStorage() {
            this.basketArray = localStorage.getItem('basket');
            if (this.basketArray) {
                this.basketArray = JSON.parse(this.basketArray);
            }
        }
    }
})